module.exports = __webpack_public_path__ + "img/item_coffee.2e428d4b.png";